import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const MagicWandOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function MagicWandOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M15.83 5.17a3 3 0 0 1 2.12 5.12L5.12 23.12c-.58.59-1.35.88-2.12.88s-1.53-.29-2.12-.88a3 3 0 0 1 0-4.24L13.71 6.05c.58-.59 1.35-.88 2.12-.88ZM2.29 20.3A.996.996 0 0 0 3 22c.16 0 .46-.04.71-.29l8.894-8.901-1.412-1.412L2.289 20.3ZM15.83 7.18c-.16 0-.46.04-.71.29l-2.514 2.512 1.411 1.412L16.54 8.87a.996.996 0 0 0 0-1.41 1.033 1.033 0 0 0-.572-.28h-.137Z" />
          <path d="M24 9h-3V7h3v2ZM23.166 2.386l-2.64 2.36-1.332-1.491 2.64-2.36 1.332 1.49ZM17 3h-2V0h2v3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default MagicWandOutlined;